document.addEventListener('DOMContentLoaded', () => {
  const mqDesktop = window.matchMedia('(min-width: 1024px)');
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const sliders = document.querySelectorAll('.swipe-desktop .swipe-desktop__inner, .swipe-desktop');
  // ^ tu peux garder seulement l’un des deux sélecteurs selon où tu écoutes le drag
  //    - Si tu écoutes sur __inner : scrolle le parent .swipe-desktop (reco)
  //    - Si tu écoutes sur .swipe-desktop : scrolle “this”

  sliders.forEach((dragTarget) => {
    // Choix: on écoute sur __inner si possible, mais on SCROLLE le parent .swipe-desktop
    const container = dragTarget.classList.contains('swipe-desktop__inner')
      ? dragTarget.closest('.swipe-desktop')
      : dragTarget;

    if (!container) return;

    let isDown = false;
    let startX = 0;
    let startLeft = 0;
    let moved = 0;

    // Capture de vitesse pour inertie
    let lastX = 0;
    let lastT = 0;
    let velocity = 0;   // px/ms (signe = direction)
    let rafId = null;

    const stopRAF = () => { if (rafId) { cancelAnimationFrame(rafId); rafId = null; } };

    const onDown = (e) => {
      if (!mqDesktop.matches || e.button !== 0) return; // desktop + clic gauche
      isDown = true;
      moved = 0;
      stopRAF(); // coupe une inertie en cours
      container.classList.add('is-dragging');

      startX = e.pageX;
      startLeft = container.scrollLeft;

      // reset vitesse
      lastX = e.pageX;
      lastT = performance.now();
      velocity = 0;

      // un suivi précis pendant le drag
      container.dataset.prevBehavior = container.style.scrollBehavior || '';
      container.style.scrollBehavior = 'auto';
      e.preventDefault();
    };

    const onMove = (e) => {
      if (!isDown) return;
      const now = performance.now();
      const dx = e.pageX - startX;

      moved = Math.max(moved, Math.abs(dx));
      container.scrollLeft = startLeft - dx;

      // calcule une vitesse lissée (px/ms)
      const dt = now - lastT || 16; // évite division par 0
      const instV = (e.pageX - lastX) / dt;
      // lissage simple (EMA)
      velocity = velocity * 0.8 + instV * 0.2;

      lastX = e.pageX; lastT = now;
    };

    const animateInertia = () => {
      // bornes
      const maxLeft = container.scrollWidth - container.clientWidth;
      const atStart = container.scrollLeft <= 0;
      const atEnd = container.scrollLeft >= maxLeft;

      // friction (plus proche de 1 = plus longue inertie)
      const friction = 0.94;        // ajuste 0.90–0.97
      const stopThreshold = 0.02;   // px/ms

      // step
      container.scrollLeft -= velocity * 16; // 16ms ~ 60fps

      // rebond doux aux limites (optionnel)
      if (container.scrollLeft <= 0 || container.scrollLeft >= maxLeft) {
        container.scrollLeft = Math.min(Math.max(container.scrollLeft, 0), maxLeft);
        velocity *= -0.2; // mini rebond
      } else {
        velocity *= friction;
      }

      if (Math.abs(velocity) < stopThreshold || prefersReduced.matches) {
        rafId = null;
        // Restaure le smooth pour laisser Scroll Snap finir proprement
        container.style.scrollBehavior = container.dataset.prevBehavior || '';
        container.classList.remove('is-dragging');
        return;
      }
      rafId = requestAnimationFrame(animateInertia);
    };

    const onUpOrLeave = () => {
      if (!isDown) return;
      isDown = false;

      // Désactive les clics fantômes si on a vraiment glissé
      if (moved > 5) {
        const stopClick = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
        dragTarget.addEventListener('click', stopClick, true);
        setTimeout(() => dragTarget.removeEventListener('click', stopClick, true), 0);
      }

      // Lance l’inertie uniquement si assez de vitesse et pas de reduced motion
      const minKick = 0.05; // px/ms ~ “lancé” perceptible
      if (Math.abs(velocity) >= minKick && !prefersReduced.matches) {
        stopRAF();
        rafId = requestAnimationFrame(animateInertia);
      } else {
        // sinon, on restaure tout de suite
        container.style.scrollBehavior = container.dataset.prevBehavior || '';
        container.classList.remove('is-dragging');
      }
    };

    // Events
    dragTarget.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUpOrLeave);
    dragTarget.addEventListener('mouseleave', onUpOrLeave);

  });
});



//Désactiver le scroll avec la souris 

// ➜ À AJOUTER (et assure-toi d'avoir supprimé tout ancien listener 'wheel' sur le slider)
document.addEventListener('DOMContentLoaded', () => {
  const mqDesktop = window.matchMedia('(min-width: 1024px)');

  // cible le conteneur scrollable
  document.querySelectorAll('.swipe-desktop').forEach((container) => {
    container.addEventListener('wheel', (e) => {
      if (!mqDesktop.matches) return;

      // Si c'est un scroll VERTICAL (molette classique) et qu'on n'appuie pas sur Shift,
      // on empêche le scroll horizontal du slider et on fait scroller la page à la place.
      if (!e.shiftKey && Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault(); // bloque le scroll horizontal du slider
        window.scrollBy({ top: e.deltaY, behavior: 'auto' }); // fait scroller la page
      }
      // Si l'utilisateur fait un vrai geste horizontal (trackpad / Shift+molette),
      // on laisse le slider scroller horizontalement (comportement natif).
    }, { passive: false });
  });
});


// DRAG AND DROP AVEC LES FLCECHES 

document.addEventListener('DOMContentLoaded', () => {
  const mqDesktop = window.matchMedia('(min-width: 1024px)');

  document.querySelectorAll('.swipe-desktop').forEach((container) => {
    const rail = container.querySelector('.swipe-desktop__inner');
    const btnPrev = container.querySelector('.swipe-desktop__btn--prev');
    const btnNext = container.querySelector('.swipe-desktop__btn--next');
    if (!rail || !btnPrev || !btnNext) return;

    // Si ton script d'inertie expose un stopper, on l'utilise (facultatif)
    const stopInertia = () => { if (typeof container._stopInertia === 'function') container._stopInertia(); };

    let step = 0;
    const computeStep = () => {
      const first = rail.children[0];
      const itemW = first ? first.getBoundingClientRect().width : rail.clientWidth;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      step = Math.round(itemW + gap);
    };
    computeStep();

    // Recalcule au resize (vw, responsive, etc.)
    const ro = new ResizeObserver(computeStep);
    ro.observe(rail);

    const scrollByStep = (dir = 1) => {
      if (!mqDesktop.matches) return;
      stopInertia();
      // assure un scroll smooth pour les flèches
      const prevBehavior = container.style.scrollBehavior;
      container.style.scrollBehavior = 'smooth';
      container.scrollBy({ left: dir * step, top: 0, behavior: 'smooth' });
      // restaure plus tard (laisse le navigateur gérer le snap si tu le réactives)
      window.setTimeout(() => { container.style.scrollBehavior = prevBehavior || ''; }, 400);
    };

    btnNext.addEventListener('click', () => scrollByStep(+1));
    btnPrev.addEventListener('click', () => scrollByStep(-1));

    // Optionnel: désactiver les flèches aux extrémités
    const updateDisabled = () => {
      const maxLeft = container.scrollWidth - container.clientWidth - 1;
      btnPrev.disabled = container.scrollLeft <= 0;
      btnNext.disabled = container.scrollLeft >= maxLeft;
    };
    container.addEventListener('scroll', updateDisabled, { passive: true });
    updateDisabled();
  });
});


